import { useQuery } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import useStore from '../../../store';
import { CountryData } from '../types';

export const useGetSupportedCountries = () => {
  const { user: { customerId }, getPersonalAccount } = useStore(state => state);
  const { accountExternalId } = getPersonalAccount();

  return useQuery(
    'useGetSupportedCountries',
    async () => {
      const { data } = await httpService.get(`${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/international/wire/out/countryList`);
      return data as CountryData;
    },
    { enabled: false },
  );
};
